"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var styled_system_1 = require("styled-system");
var Styles_1 = require("./forms/Styles");
var Flex_1 = __importDefault(require("./Flex"));
var Icon_1 = __importDefault(require("./Icon"));
var ClickableIcon = styled_components_1["default"](Icon_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n"], ["\n  pointer-events: none;\n"])));
var SelectBase = styled_components_1["default"].select(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  ", "\n\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n\n  ", "\n  ", "\n"])), Styles_1.borders, Styles_1.field, styled_system_1.space, Styles_1.disabled);
var Select = styled_components_1["default"](function (_a) {
    var icon = _a.icon, rest = __rest(_a, ["icon"]);
    return (react_1["default"].createElement(Flex_1["default"], { width: 1, align: "center" },
        react_1["default"].createElement(SelectBase, __assign({}, rest)),
        icon || react_1["default"].createElement(ClickableIcon, { size: 12, ml: -32, name: "chevronDown" })));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
// @ts-ignore
Select.isField = true;
exports["default"] = Select;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Select.js.map